export default "__VITE_ASSET__DmUSKUd7__"